export const origins = {
  develop: 'https://develop.hirevibes.io',
  localhost: 'http://localhost:8080',
  production: 'https://app.hirevibes.com'
}

export const roles = {
  hirer: 'hirer'
}



// WEBPACK FOOTER //
// ./src/constants/general-constants.js